import { ColorHexMap } from '../../images/avatar-creator/ColorHexValues';

// Color palette arrays indexed by user selection
const SkinColorsMain = [
    "PaleSkinColorMain", "LightSkinColorMain", "BeigeSkinColorMain",
    "OrangeBeigeSkinColorMain", "YellowSkinColorMain", "DarkYellowSkinColorMain",
    "TannedSkinColorMain", "RedSkinColorMain", "AmberSkinColorMain",
    "DarkAmberSkinColorMain", "BrownSkinColorMain", "DarkBrownSkinColorMain",
    "GreenSkinColorMain", "GreySkinColorMain", "BlueSkinColorMain",
    "PinkSkinColorMain",
];

const SkinColorsShade = [
    "PaleSkinColorShade", "LightSkinColorShade", "BeigeSkinColorShade",
    "OrangeBeigeSkinColorShade", "YellowSkinColorShade", "DarkYellowSkinColorShade",
    "TannedSkinColorShade", "RedSkinColorShade", "AmberSkinColorShade",
    "DarkAmberSkinColorShade", "BrownSkinColorShade", "DarkBrownSkinColorShade",
    "GreenSkinColorShade", "GreySkinColorShade", "BlueSkinColorShade",
    "PinkSkinColorShade",
];

const SkinColorsCheeks = [
    "PaleSkinColorCheeks", "LightSkinColorCheeks", "BeigeSkinColorCheeks",
    "OrangeBeigeSkinColorCheeks", "YellowSkinColorCheeks", "DarkYellowSkinColorCheeks",
    "TannedSkinColorCheeks", "RedSkinColorCheeks", "AmberSkinColorCheeks",
    "DarkAmberSkinColorCheeks", "BrownSkinColorCheeks", "DarkBrownSkinColorCheeks",
    "GreenSkinColorCheeks", "GreySkinColorCheeks", "BlueSkinColorCheeks",
    "PinkSkinColorCheeks",
];

const HairColorsMain = [
    "BlondeHairColorMain", "LightBlondeHairColorMain", "GoldenBlondeHairColorMain",
    "PlatinumHairColorMain", "SilverHairColorMain", "LightBrownHairColorMain",
    "EspressoHairColorMain", "ChestnutHairColorMain", "DarkBrownHairColorMain",
    "OrangeHairColorMain", "GingerHairColorMain", "CopperHairColorMain",
    "HotRedHairColorMain", "PurpleHairColorMain", "HotPinkHairColorMain",
    "BlackHairColorMain",
];

const HairColorsShade = [
    "BlondeHairColorShade", "LightBlondeHairColorShade", "GoldenBlondeHairColorShade",
    "PlatinumHairColorShade", "SilverHairColorShade", "LightBrownHairColorShade",
    "EspressoHairColorShade", "ChestnutHairColorShade", "DarkBrownHairColorShade",
    "OrangeHairColorShade", "GingerHairColorShade", "CopperHairColorShade",
    "HotRedHairColorShade", "PurpleHairColorShade", "HotPinkHairColorShade",
    "BlackHairColorShade",
];

const OutfitColorsMain = [
    "RedOutfitColorMain", "SalmonOutfitColorMain", "OrangeOutfitColorMain",
    "HoneyYellowOutfitColorMain", "GoldOutfitColorMain", "GreenYellowOutfitColorMain",
    "GreenOutfitColorMain", "SeaGreenOutfitColorMain", "MintOutfitColorMain",
    "TurqoiseOutfitColorMain", "LightSkyBlueOutfitColorMain", "RoyalBlueOutfitColorMain",
    "SlateGreyOutfitColorMain", "LavenderOutfitColorMain", "PurpleOutfitColorMain",
    "HotPinkOutfitColorMain",
];

const OutfitColorsShade = [
    "RedOutfitColorShade", "SalmonOutfitColorShade", "OrangeOutfitColorShade",
    "HoneyYellowOutfitColorShade", "GoldOutfitColorShade", "GreenYellowOutfitColorShade",
    "GreenOutfitColorShade", "SeaGreenOutfitColorShade", "MintOutfitColorShade",
    "TurqoiseOutfitColorShade", "LightSkyBlueOutfitColorShade", "RoyalBlueOutfitColorShade",
    "SlateGreyOutfitColorShade", "LavenderOutfitColorShade", "PurpleOutfitColorShade",
    "HotPinkOutfitColorShade",
];

const OutfitColorsAccent = [
    "RedOutfitColorAccent", "SalmonOutfitColorAccent", "OrangeOutfitColorAccent",
    "HoneyYellowOutfitColorAccent", "GoldOutfitColorAccent", "GreenYellowOutfitColorAccent",
    "GreenOutfitColorAccent", "SeaGreenOutfitColorAccent", "MintOutfitColorAccent",
    "TurqoiseOutfitColorAccent", "LightSkyBlueOutfitColorAccent", "RoyalBlueOutfitColorAccent",
    "SlateGreyOutfitColorAccent", "LavenderOutfitColorAccent", "PurpleOutfitColorAccent",
    "HotPinkOutfitColorAccent",
];

const OutfitColorsShadow = [
    "RedOutfitColorShadow", "SalmonOutfitColorShadow", "OrangeOutfitColorShadow",
    "HoneyYellowOutfitColorShadow", "GoldOutfitColorShadow", "GreenYellowOutfitColorShadow",
    "GreenOutfitColorShadow", "SeaGreenOutfitColorShadow", "MintOutfitColorShadow",
    "TurqoiseOutfitColorShadow", "LightSkyBlueOutfitColorShadow", "RoyalBlueOutfitColorShadow",
    "SlateGreyOutfitColorShadow", "LavenderOutfitColorShadow", "PurpleOutfitColorShadow",
    "HotPinkOutfitColorShadow",
];

/**
 * Resolves a Color index (1-9) to an actual hex color string
 * based on the user's selected palette indices.
 *
 * Color index mapping:
 *   1 = Skin Main
 *   2 = Skin Shade
 *   3 = Hair Shade
 *   4 = Hair Main
 *   5 = Outfit Main
 *   6 = Outfit Shade
 *   7 = Outfit Accent
 *   8 = Outfit Shadow
 *   9 = Skin Cheeks
 */
export function resolveColor(colorIndex, skinIdx, hairIdx, outfitIdx) {
    let colorName = null;

    switch (colorIndex) {
        case 1:
            colorName = SkinColorsMain[skinIdx];
            break;
        case 2:
            colorName = SkinColorsShade[skinIdx];
            break;
        case 3:
            colorName = HairColorsShade[hairIdx];
            break;
        case 4:
            colorName = HairColorsMain[hairIdx];
            break;
        case 5:
            colorName = OutfitColorsMain[outfitIdx];
            break;
        case 6:
            colorName = OutfitColorsShade[outfitIdx];
            break;
        case 7:
            colorName = OutfitColorsAccent[outfitIdx];
            break;
        case 8:
            colorName = OutfitColorsShadow[outfitIdx];
            break;
        case 9:
            colorName = SkinColorsCheeks[skinIdx];
            break;
        default:
            return null;
    }

    return colorName ? (ColorHexMap[colorName] || null) : null;
}

// Export palette arrays for UI color swatches
export const skinSwatches = SkinColorsMain.map(name => ColorHexMap[name]);
export const hairSwatches = HairColorsMain.map(name => ColorHexMap[name]);
export const outfitSwatches = OutfitColorsMain.map(name => ColorHexMap[name]);

export const SKIN_COUNT = SkinColorsMain.length;
export const HAIR_COUNT = HairColorsMain.length;
export const OUTFIT_COUNT = OutfitColorsMain.length;
